import { render, staticRenderFns } from "./roleBasedAccessControl.vue?vue&type=template&id=0fb11bae&scoped=true&"
import script from "./roleBasedAccessControl.vue?vue&type=script&lang=js&"
export * from "./roleBasedAccessControl.vue?vue&type=script&lang=js&"
import style0 from "./roleBasedAccessControl.vue?vue&type=style&index=0&id=0fb11bae&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fb11bae",
  null
  
)

export default component.exports